import { render, staticRenderFns } from "./ZuCard.vue?vue&type=template&id=2c32c6c6&scoped=true"
import script from "./ZuCard.vue?vue&type=script&lang=js"
export * from "./ZuCard.vue?vue&type=script&lang=js"
import style0 from "./ZuCard.vue?vue&type=style&index=0&id=2c32c6c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c32c6c6",
  null
  
)

export default component.exports